<template>
  <div>
    <app-toolbar :crumbs="localCrumbs">
      <v-spacer></v-spacer>
      <knowledge-check-edit
        v-if="knowledgeCheck.id"
        v-model="knowledgeCheck"
        :api="proceduresApi"
        @save="onSave"
      />
    </app-toolbar>

    <knowledge-check-detail
      v-if="model.id"
      v-model="knowledgeCheck"
      :entityType="'procedure'"
      :entityId="procedureId"
      :api="proceduresApi"
      @save="onSave"
    />

    <div class="mt-2">
      <questions-table
        :procedureId="procedureId"
        :mediaOptions="mediaOptions"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { procedures as proceduresApiBuilder } from '@/services/api'
import contentPageMixin from '@/components/mixins/content-page'
import KnowledgeCheckDetail from '@/components/knowledgeCheck/detail.vue'
import KnowledgeCheckEdit from '@/components/knowledgeCheck/edit.vue'
import QuestionsTable from '@/components/knowledgeCheck/questions-table.vue'

export default {
  mixins: [contentPageMixin],
  components: {
    KnowledgeCheckDetail,
    KnowledgeCheckEdit,
    QuestionsTable
  },
  data() {
    return {
      knowledgeCheck: {},
      model: {},
      proceduresApi: null
    }
  },
  computed: {
    localCrumbs() {
      const items = [...this.moduleCrumbs]
      items.push({
        text: 'Knowledge Check',
        disabled: true
      })
      return items
    },
    mediaOptions() {
      return {
        showUpload: true,
        title: 'Media Selector',
        moduleId: this.moduleId,
        componentId: this.componentId,
        procedureId: this.procedureId,
        topicId: this.topicId,
        entityId: this.procedureId,
        entityType: 'procedure'
      }
    }
  },
  async mounted() {
    this.proceduresApi = proceduresApiBuilder.build(
      this.module.id,
      this.componentId
    )
    this.model = this.procedure
    this.knowledgeCheck = await this.proceduresApi.knowledgeCheck.fetch(
      this.procedure.id
    )
  },
  watch: {
    procedure(val) {
      this.model = _.cloneDeep(val)
    }
  },
  methods: {
    onSave(model) {
      this.knowledgeCheck = { ...model }
    }
  }
}
</script>
